import React from "react";
import imgv2c from "../img/imgv2c.png";
function Footer() {
  return (
    <div>
      <div className="footer-2 bg-gray-800 pt-6 md:pt-12">
        <div className="container px-4 mx-auto">
          <div className="md:flex md:flex-wrap md:-mx-4 py-6 md:pb-12">
            <div className="footer-info lg:w-1/3 md:px-4">
              <h4 className=" text-orange-600 text-2xl mb-4">
              Aquaponics Market Global Size:
              </h4>
              <p className="text-gray-400">
              Aquaponics Market is valued at USD 863.5 Million in 2021 and is expected to reach USD 1985.3 Million by 2028 with a CAGR of 12.60% over the forecast period
              </p>
              <div className="mt-4">
                <button className="bg-facebook py-2 px-4 text-white rounded mt-2 transition-colors duration-300">
                  <span className="fab fa-facebook-f mr-2"></span> Follow
                </button>
                <button className="bg-twitter py-2 px-4 text-white rounded ml-2 mt-2 transition-colors duration-300">
                  <span className="fab fa-twitter mr-2"></span>  <a href="https://www.instagram.com/v2c_farming/?igshid=YmMyMTA2M2Y%3D">Follow @TECHCLAN</a>  
                </button>
              </div>
              
            </div>
            <div className="md:w-2/3 lg:w-1/3 md:px-4 xl:pl-16 mt-12 lg:mt-0">
              <div className="sm:flex">
                <div className="sm:flex-1">
                </div>
                <div className="sm:flex-1 mt-4 sm:mt-0">
                  <h6 className="text-base font-medium  text-orange-600 uppercase mb-2">
                    Product
                  </h6>
                  <div>
                    <a
                      href="#"
                      className="text-gray-400 py-1 block hover:underline"
                    >
                      Farm Management
                    </a>
                    <a
                      href="#"
                      className="text-gray-400 py-1 block hover:underline"
                    >
                      Precision Farming
                    </a>
                    <a
                      href="#"
                      className="text-gray-400 py-1 block hover:underline"
                    >
                      Farm Analytics
                    </a>

                  </div>
                </div>
                <img 
              src={imgv2c}
              className="w-full h-full object-contain px-16 sm:flex-1 mt-4 sm:mt-0"
              alt="delivery"
            />
          </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-solid border-gray-900 mt-4 py-4">
          <div className="container px-4 mx-auto">
            <div className="md:flex md:-mx-4 md:items-center">
              <div className="md:flex-1 md:px-4 text-center md:text-left">
                <p className="text-white">
                  &copy; <strong>TECHCLAN</strong>
                </p>
              </div>
              <div className="w-10 h-10 bg-white rounded-full overflow-hidden drop-shadow-xl">
              <div className="md:flex-1 md:px-4 text-center md:text-right">
                <a
                  href="#"
                  className="py-2 px-4 text-white inline-block hover:underline"
                >
                  Terms of Service
                </a>
                <a
                  href="#"
                  className="py-2 px-4 text-white inline-block hover:underline"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
